// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: which panel, if any, the phone rail has grown into. More, Ask and
// From Konvo (what Konvo has ready) all expand the rail upward into the same
// glass panel; only one is open at a time and any route change closes it.

import {makeAutoObservable} from 'mobx';

export type MobileRailPanel = 'more' | 'ask' | 'ready';

class MobileRailPanelStateStore {
	open: MobileRailPanel | null = null;
	/** Text to seed the Ask field with when the Ask panel opens (e.g. from Konvo suggests). */
	askPrefill: string | null = null;
	/** When true the Ask panel submits the prefill immediately on open. */
	askAutoSend = false;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	openMore(): void {
		this.open = 'more';
		this.askPrefill = null;
		this.askAutoSend = false;
	}

	/** The From Konvo list (ReadyList.openInRail, which also loads it). */
	openReady(): void {
		this.open = 'ready';
		this.askPrefill = null;
		this.askAutoSend = false;
	}

	openAsk(prefill: string | null = null, autoSend = false): void {
		this.open = 'ask';
		this.askPrefill = prefill;
		this.askAutoSend = autoSend;
	}

	toggle(panel: MobileRailPanel): void {
		if (this.open === panel) this.close();
		else if (panel === 'more') this.openMore();
		else if (panel === 'ready') this.openReady();
		else this.openAsk();
	}

	close(): void {
		this.open = null;
		this.askPrefill = null;
		this.askAutoSend = false;
	}

	consumeAskPrefill(): {text: string; autoSend: boolean} | null {
		if (this.askPrefill == null) return null;
		const result = {text: this.askPrefill, autoSend: this.askAutoSend};
		this.askPrefill = null;
		this.askAutoSend = false;
		return result;
	}
}

export default new MobileRailPanelStateStore();
